define('drops/pushNotificationReceiver/pushNotificationReceiver',[
    'jquery', 
    'underscore',
    'lq/main',
    'lq/drop',
    'lq/webPushNotifications'
], function ($, _, main, Drop, webPushNotifications) {
    'use strict';
    
    function PushNotificationReceiver(options) {
        Drop.call(this, $('<div />'), options);
        this.listener = this.handleNotification.bind(this, false);
    };

    Drop.extend(PushNotificationReceiver);

    PushNotificationReceiver.typeName = 'PushNotificationReceiver';

    PushNotificationReceiver.prototype.postRender = function() {
        if (main.areWebNotificationsEnabled())
            this.piping.eventing.onPageLoad(this.initializeForWeb.bind(this));
    };

    PushNotificationReceiver.prototype.initializeForWeb = function (continuation) {
        var self = this;
        webPushNotifications.startReceivingNotifications(this.piping.application.userId, function (permissionType, deviceId) {
            if (permissionType === 'granted')
                self.triggerEventIfEnabled('receiverLoaded', deviceId);
        });

        if (webPushNotifications.hasReceivedNotifications()) {
            var notifications = webPushNotifications.getAllReceivedNotifications();

            // wait until all drops are loaded before we trigger this event
            this.piping.eventing.onPageLoad(this.handleNotifications.bind(this, true, notifications));
        }

        webPushNotifications.addListener(this.listener);

        continuation();
    };

    PushNotificationReceiver.prototype.handleNotifications = function (isBackground, notifications, continuation) {
        _.each(notifications, this.handleNotification.bind(this, isBackground));
        continuation();
    };

    PushNotificationReceiver.prototype.handleNotification = function (isBackground, notification) {
        var self = this;
        _.each(_.keys(notification), function (prop) {
            self.piping.parameters.locals.setValue(prop, notification[prop]);
        });

        if (isBackground)
            this.triggerEventIfEnabled('backgroundNotificationReceived');
        else
            this.triggerEventIfEnabled('foregroundNotificationReceived');

    };

    PushNotificationReceiver.prototype.unsubscribeEventHandlers = function () {
        webPushNotifications.removeListener(this.listener);
    };

    return PushNotificationReceiver;
});
